import { render } from "./ProfileBox.vue?vue&type=template&id=6041b049"
import script from "./ProfileBox.vue?vue&type=script&lang=js"
export * from "./ProfileBox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__